import React from 'react';

const CimsRoute = ({ children }) => {
  return children;
};

export default CimsRoute;
